import type { Task } from "@/api.types.v2";

/** Resolve a task's order / shipment display numbers from either the live
 * shipment or its snapshot (mirrors selected-tasks-list's resolution). */
export function taskRefs(task: Task): {
  orderNumber?: number;
  shipmentNumber?: number;
} {
  const shipmentNumber =
    (task.shipment as { shipmentNumber?: number } | null)?.shipmentNumber ??
    (task.shipmentSnapshot as { shipmentNumber?: number } | null)
      ?.shipmentNumber;
  const orderNumber =
    (task.shipment as { order?: { orderNumber?: number } } | null)?.order
      ?.orderNumber ??
    (task.shipmentSnapshot as { orderNumber?: number } | null)?.orderNumber;
  return {
    orderNumber:
      typeof orderNumber === "number" && orderNumber > 0
        ? orderNumber
        : undefined,
    shipmentNumber:
      typeof shipmentNumber === "number" && shipmentNumber > 0
        ? shipmentNumber
        : undefined,
  };
}

/** "123 King St W, Toronto" — best-effort single-line address. */
export function taskAddressLine(task: Task): string {
  const line1 = task.address?.line1 ?? task.addressLine1;
  const city = task.address?.city ?? task.addressCity;
  if (!line1) return "Unknown location";
  return [line1, city].filter(Boolean).join(", ");
}

export function taskRoutingPin(task: Task): string | null {
  const lat = task.addressLatitude ?? task.address?.location?.lat;
  const lng = task.addressLongitude ?? task.address?.location?.lng;
  return lat != null &&
    lng != null &&
    Number.isFinite(Number(lat)) &&
    Number.isFinite(Number(lng))
    ? `${Number(lat)},${Number(lng)}`
    : null;
}
